import { WorkflowQuestionConfig } from './workflowQuestionConfig';

export interface WorkflowPageConfig {
  id: string;
  name: string;
  order: number;
  instructions?: string;
  questions: WorkflowQuestionConfig[];
}
